import { render, staticRenderFns } from "./juridical.vue?vue&type=template&id=61a05d5d&scoped=true"
import script from "./juridical.vue?vue&type=script&lang=js"
export * from "./juridical.vue?vue&type=script&lang=js"
import style0 from "./juridical.vue?vue&type=style&index=0&id=61a05d5d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a05d5d",
  null
  
)

export default component.exports